/* eslint-disable max-len */
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

// Configure the worker for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function PDFView(props) {
  const { path } = props;
  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = (obj) => {
    setNumPages(obj.numPages);
  };

  const onDocumentLoadError = (error) => {
    // eslint-disable-next-line no-console
    console.error('Doc Load Error: ', error);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: 1,
      }}
    >
      <Document
        file={path}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
      >
        {numPages && [...Array(numPages).keys()]
          .map((x, i) => i + 1)
          .map((page) => <Page key={page} pageNumber={page} />)}
      </Document>
      {/* <Box sx={{
        display: 'flex', justifyContent: 'space-around', gap: 3, alignItems: 'center',
      }}
      >
        <Button
          disabled={pageNumber === 1}
          size="small"
          variant="contained"
          color="primary"
          onClick={() => setPageNumber((prevNumber) => prevNumber - 1)}
        >
          {'<'}
        </Button>
        Page
        {' '}
        {pageNumber}
        {' '}
        /
        {' '}
        {numPages}
        <Button
          disabled={pageNumber === numPages}
          size="small"
          variant="contained"
          color="primary"
          onClick={() => setPageNumber((prevNumber) => prevNumber + 1)}
        >
          {'>'}
        </Button>
      </Box> */}
    </Box>
  );
}
